import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    html: {
        myRdv: "Mes rendez-vous"
    }
};

export type I18nAgenda = typeof _fr;

const _en: I18nAgenda = {
    html: {
        myRdv: "My Appointments"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nAgenda {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}